import React from "react";
import {isMobile} from "../helpers/ApplicationHelper";
import SoldItemPreview from "./soldItemPreview";

class SimilarItems extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const MAX_SIMILAR_ITEMS_COUNT = 4;
        const {items, goTo, item} = this.props;
        let sortedItems = items && items.length > 1 ? items.sort((a, b) => b.sold_for - a.sold_for).slice(0, MAX_SIMILAR_ITEMS_COUNT) : [];
        return <div className='similar-items-container'>
            {
                sortedItems.map(i => <a onClick={ () => {
                    goTo(i['item_deal_page'], `Similar item with ID «${i.id}» has been clicked`, item.id, true)
                }} key={i.id} target={isMobile() ? '_self': '_blank'}>
                    <SoldItemPreview page='listingPage' key={i.id} item={i} hideSoldFor={this.props.hideSoldFor}/>
                </a>)
            }
        </div>
    }
}

export default SimilarItems;
